var path = 'app/sections/widgets/editor/common/widgetEditorMenu.html';
var html = "<div class=\"widget-toolbar\">\n  <ng-transclude />\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;